// Define the composable function
export function useInspectlet() {
    // Constant for Inspectlet wid
    const wid = 762405575;
  
    // Function to load Inspectlet script
    const initInspectlet = async () => {
      // Check if window is defined and Inspectlet is not already initialized
      if (typeof window !== 'undefined' && !window.__insp) {
        window.__insp = window.__insp || [];
        __insp.push(['wid', wid]);
  
        // Create script element
        const insp = document.createElement('script');
        insp.type = 'text/javascript';
        insp.async = true;
        insp.id = "inspsync";
        insp.src = `https://cdn.inspectlet.com/inspectlet.js?wid=${wid}&r=${Math.floor(new Date().getTime() / 3600000)}`;
  
        // Append the script to the document
        const firstScript = document.getElementsByTagName('script')[0];
        firstScript.parentNode.insertBefore(insp, firstScript);
  
        return new Promise((resolve, reject) => {
          // Event handlers for script loading
          insp.onload = () => {
            console.log("Inspectlet script loaded successfully.");
            resolve(true);
          };
          insp.onerror = (error) => {
            console.error("Error loading Inspectlet script:", error);
            reject(error);
          };
        });
      }
    };
  
    return { initInspectlet };
  }
  